import React, { useMemo } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

const UserStandardHourForm = ({
    isOpen,
    onClose,
    onSubmit,
    formData,
    setFormData,
    isEditing,
    categories,
    users,
    isAdminView
}) => {
    const categoryOptions = useMemo(() => {
        return (categories || []).map(cat => ({
            label: `${cat.Name} (${cat.Score} giờ)`,
            value: cat.Id,
            score: cat.Score
        }));
    }, [categories]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleCategoryChange = (e) => {
        const selectedId = e.value;

        if (selectedId) {
            const selectedOption = categoryOptions.find(opt => opt.value == selectedId);

            setFormData({
                ...formData,
                StandardHourId: selectedId,
                ActualPercentage: selectedOption ? selectedOption.score : ''
            });
        } else {
            setFormData({
                ...formData,
                StandardHourId: '',
                ActualPercentage: ''
            });
        }
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString, type: 'text' } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box" style={{ width: '90%', maxWidth: '700px' }}>
                <div className="modal-header">
                    <h3>{isEditing ? "Cập nhật Mục giờ định mức" : "Thêm mới Mục giờ định mức"}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <form id="ushForm" onSubmit={onSubmit}>

                        {isAdminView && users && (
                            <div className="form-group" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', borderLeft: '4px solid #3498db' }}>
                                <label style={{ color: '#003399', fontWeight: 'bold' }}>Chọn giảng viên kê khai hộ *</label>
                                <select
                                    name="UserId"
                                    className="form-input"
                                    value={formData.UserId || ''}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Vui lòng chọn giảng viên</option>
                                    {users.map(u => {
                                        const fullName = u.FullName || ((u.LastName || '') + ' ' + (u.FirstName || '')).trim() || 'Chưa cập nhật tên';
                                        return (
                                            <option key={u.Id} value={u.Id}>
                                                {fullName} - {u.Email}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                Chọn mục giờ chuẩn *
                            </label>
                            <Dropdown
                                id="StandardHourId"
                                name="StandardHourId"
                                value={formData.StandardHourId ? Number(formData.StandardHourId) : null}
                                options={categoryOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={handleCategoryChange}
                                placeholder="Vui lòng chọn mục giờ chuẩn"
                                filter
                                filterPlaceholder="Nhập từ khóa để tìm kiếm"
                                style={{
                                    width: '100%',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '6px',
                                    padding: '10px 10px'
                                }}
                                panelStyle={{ maxWidth: '650px' }}
                                itemTemplate={(option) => (
                                    <div style={{ whiteSpace: 'normal', lineHeight: '1.5' }}>
                                        {option.label}
                                    </div>
                                )}
                                emptyMessage="Không có dữ liệu"
                                emptyFilterMessage="Không tìm thấy kết quả phù hợp"
                                required
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '20px' }}>
                            <label>Giờ chuẩn thực tế *</label>
                            <input type="number" step="0.1" name="ActualPercentage" className="form-input" placeholder="Nhập giá trị 0, 100, 200, ..." value={formData.ActualPercentage} onChange={handleChange} required />
                        </div>

                        <div className="form-grid-2" style={{ marginBottom: '20px' }}>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày bắt đầu *</label>
                                <Calendar
                                    id="StartDate"
                                    name="StartDate"
                                    value={(formData.StartDate && !isNaN(new Date(formData.StartDate).getTime())) ? new Date(formData.StartDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('StartDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày kết thúc *</label>
                                <Calendar
                                    id="EndDate"
                                    name="EndDate"
                                    value={(formData.EndDate && !isNaN(new Date(formData.EndDate).getTime())) ? new Date(formData.EndDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('EndDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Ghi chú</label>
                            <textarea name="Notes" className="form-input" rows="3" value={formData.Notes} onChange={handleChange}></textarea>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="ushForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default UserStandardHourForm;